import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { formatDateToMDY, formatDateToDDMMYY } from '../../constants/utils';

const DatePickerMui = ({
  label = null,
  defaultValue = null,
  handleDateChange = () => {},
  style = {},
  resetValue,
  handleReset = () => {},
  updateDateValue = '',
  passUnformattedDate = false,
  useDDMMYYFormat = false,
  ...restProps
}) => {
  const [value, setValue] = useState(defaultValue);
  const setDate = (newValue) => {
    setValue(newValue);
    if (handleDateChange && !passUnformattedDate && newValue !== null) {
      const formattedDate = useDDMMYYFormat
        ? formatDateToDDMMYY(newValue)
        : formatDateToMDY(newValue);
      handleDateChange(formattedDate);
    } else if (newValue !== null) {
      handleDateChange(newValue);
    }
  };

  useEffect(() => {
    if (resetValue) {
      setValue(defaultValue);
      handleReset();
    }
    setValue(defaultValue);
  }, [resetValue, defaultValue]);

  useEffect(() => {
    if (updateDateValue?.length) {
      setDate(new Date(updateDateValue));
    } else if (updateDateValue === null) {
      setDate(null);
    }
  }, [updateDateValue]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={value}
        onChange={(newValue) => setDate(newValue)}
        format={useDDMMYYFormat ? 'dd/MM/yy' : 'MM/dd/yyyy'}
        slotProps={{ textField: { variant: 'standard' } }}
        sx={{ width: '150px', paddingRight: '20px', ...style }}
        {...restProps}
      />
    </LocalizationProvider>
  );
};

// Prop validation
DatePickerMui.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  handleDateChange: PropTypes.func,
  style: PropTypes.object,
  resetValue: PropTypes.any,
  handleReset: PropTypes.func,
  updateDateValue: PropTypes.any,
  passUnformattedDate: PropTypes.bool,
  useDDMMYYFormat: PropTypes.bool,
};

export default DatePickerMui;
